import { useUserStore } from '@/store/user/useUserStore'
import { useConfigStore } from '@/store/config/useConfigStore'
import { useMemo } from 'react'
import { isDev } from '@/env'

const usePermissions = () => {
  const userInfo = useUserStore((state) => state.userInfo)
  const config = useConfigStore((state) => state.config)

  const isStation = useMemo(() => {
    return (config?.creditSystem === 0 && config?.bettingStation === 1 && userInfo?.userType === 'ZDL') || userInfo?.userType === 'SZZH'
  }, [userInfo, config])

  return {
    // 是否是投注站(包括子账号)
    isStation,
    // 是否是開發中的投注站
    isDevelopingStation: isDev && isStation,
  }
}

export default usePermissions
